<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择SAP物料信息"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="baseMaterials">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="物料描述">
            <el-input v-model.trim="filter.name" clearable/>
          </vm-search>
          <vm-search label="物料组">
            <el-input v-model.trim="filter.materialGroupNO" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="no" align="center" label="物料编号" width="90px"/>
      <el-table-column prop="name" align="center" label="物料描述" width="150px"/>
      <el-table-column prop="unit" align="center" label="物料单位" width="75px"/>
      <el-table-column prop="materialGroupNO" align="center" label="物料组" width="60px"/>
      <el-table-column prop="productGroupNO" align="center" label="产品组" width="60px"/>
      <el-table-column prop="purchaseGroupNO" align="center" label="采购组" width="60px"/>
      <el-table-column prop="minStock" align="center" label="最低库存"/>
      <el-table-column prop="maxStock" align="center" label="最高库存"/>
      <el-table-column prop="mainProductionLine" align="center" label="主产线">
        <template slot-scope="scope">
          <span>{{productionLines[scope.row.mainProductionLine]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="viceProductionLine" align="center" label="辅线">
        <template slot-scope="scope">
          <span>{{productionLines[scope.row.viceProductionLine]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productionTime" align="center" label="工时" width="45px"/>
      <el-table-column prop="configurableFlag" align="center" label="是否可配置">
        <template slot-scope="scope">
          <el-tag>
            {{scope.row.configurableFlag === "X" ? "是":"否"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="70px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";


  export default {
    name:"MaterialManagementSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        constant,
        productionLines: constant.productionLine,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          no: "",
          name: "",
          materialGroupNO: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
